import { DynamicModule } from '1-project/DynamicModule/DynamicModule';
import { UI_GoToTopNavigation } from 'ui/components/3-organisms/GoToTopNavigation/GoToTopNavigation';
import { useDictionaryContext } from '3-foundation/Dictionary/DictionaryContext';
import { MainRegion } from '1-project/MainRegion/MainRegion';
import { Speaker } from '2-feature/Speaker/Speaker';
import { Breadcrumb } from '2-feature/Navgation/Breadcrumb';

interface Props extends Content.Page {
	properties: Content.BasePage & Content.SiteSetting;
}

export const SubjectPage = (props: Props) => {
	const { properties } = props;
	const { pageHeader, pageSections } = properties ?? {};
	const dictionary = useDictionaryContext();
	const toTopTitle = dictionary.getAction('ToTop');
	const headerComponentIsHero = pageHeader?.[0]?.documentType?.startsWith('hero');

	return (
		<MainRegion
			header={pageHeader.map((headerModule, index) => (
				<DynamicModule key={index} module={headerModule} />
			))}
			speaker={<Speaker background={headerComponentIsHero ? 'Primary' : null} />}
			breadCrumb={<Breadcrumb background={headerComponentIsHero ? 'Primary' : null} />}
		>
			{pageSections.map((sectionModule, index) => (
				<DynamicModule key={index} module={sectionModule} />
			))}
			<UI_GoToTopNavigation title={toTopTitle} />
		</MainRegion>
	);
};
